import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { generatePath as routerGeneratePath } from 'react-router-dom';
import { PathParam } from '@remix-run/router/utils.ts';
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function generateApiPath<Path extends string>(
  originalPath: Path,
  params: {
    [key in PathParam<Path>]: string | null;
  } = {} as any
): string {
  const path = routerGeneratePath(originalPath, params);
  return path.replace(/\/?(\?|#|$)/, '/$1');
}
